export default function removeParenthesisStringUtil (input) {
  return input.replace(/[()]/gi, '')
}
